import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { TreeNode } from 'primeng/api';

import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';

@Component({
	selector: 'app-folder-add',
	templateUrl: './folder-add.component.html',
	styleUrls: ['./folder-add.component.scss']
})
export class FolderAddComponent extends DialogPage implements OnInit {

	// Specific values if used with forced values.
	public _forceCompany: any = "";
	public _forceUser: any = "";

	// Form data.
	active = 1;
	folderAddForm = new FormGroup({
		nameControl: new FormControl('', [Validators.required]),
		pathControl: new FormControl('', [Validators.required]),
		engineerControl: new FormControl('', [Validators.required]),
		endDateControl: new FormControl(''),
		usersControl: new FormControl([]),
		companiesControl: new FormControl([]),

		// Email.
		emailSubjectControl: new FormControl('', [Validators.required]),
		emailIntroControl: new FormControl(this.constantsModule.mailTemplateFolderCreationIntro),
		emailLinkControl: new FormControl(this.constantsModule.mailTemplateFolderCreationLink),
		emailInfoBillControl: new FormControl(this.constantsModule.mailTemplateFolderCreationInfoBill),
		emailInfoAnswerControl: new FormControl(this.constantsModule.mailTemplateFolderCreationInfoAnswer),
		emailNotaControl: new FormControl(this.constantsModule.mailTemplateFolderCreationNota),
		emailLinkValidControl: new FormControl(this.constantsModule.mailTemplateFolderCreationLinkValid),
		emailMoreInfoControl: new FormControl(this.constantsModule.mailTemplateFolderCreationMoreInfo),
		emailSignatureControl: new FormControl(this.constantsModule.mailTemplateFolderCreationSignature),
		emailSendToUserControl: new FormControl(true),
	});

  // Datas list.
	public treeStructure: TreeNode[] = [];
	public selectedFolder: TreeNode = {};
	public engineersList: any[] = [];
	public usersList: any[] = [];
	public companiesList: any[] = [];

	// Extra data.
	public buttonText: string;
	public enableAction: boolean;

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Ajouter";
		this.enableAction = true;
	}

	ngOnInit(): void {
		this.put("/api/folder-browse-list", undefined, 
		(response: any) => {
			if (response.DATA == "ERR") {
			switch (response.VALUE) {
				case "UNAUTHORIZED":
				this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
				break;
				case "TREE DATA RECOVERY":
				this.alertLine.alertDangerMessage = "Impossible de récupérer la liste des dossiers. Contactez votre administrateur.";
				break;
				default:
				this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
				break;
			}
			} else {
				this.treeStructure = <TreeNode[]> response.RES;
			}
		},
		(err: any) => {
			// Cannot load the data.
			this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
		}
		);

		this.put("/api/user-list-usernames", undefined, 
		(response: any) => {
			if (response.DATA == "ERR") {
			switch (response.VALUE) {
				case "UNAUTHORIZED":
				this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
				break;
				case "DATABASE":
				this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
				break;
				default:
				this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
				break;
			}
			} else {
				this.usersList = response.RES;
				// Forcing for a specific user.
				if (this._forceUser) {
					this.folderAddForm.controls["usersControl"].setValue([{_id: this._forceUser.id, username: this._forceUser.username}]);
					this.folderAddForm.controls["usersControl"].disable();
				}
			}
		},
		(err: any) => {
			// Cannot load the data.
			this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
		}
		);

		this.put("/api/user-engineer-list", undefined,
			(response:any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
						case "UNAUTHORIZED":
							this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
							break;
						case "DATABASE":
							this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
							break;
						default:
							this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
							break;
					}
				} else {
					this.engineersList = response.RES;
					if (this._forceUser) this.engineersList = this.engineersList.filter(engineer => engineer._id.toString() != this._forceUser.id);
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
			}
		);

		this.put("/api/company-list-names", undefined, 
		(response: any) => {
			if (response.DATA == "ERR") {
			switch (response.VALUE) {
				case "UNAUTHORIZED":
				this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
				break;
				case "DATABASE":
				this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
				break;
				default:
				this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
				break;
			}
			} else {
			this.companiesList = response.RES;

			// Forcing for a specific company.
			if (this._forceCompany) {
				this.folderAddForm.controls["companiesControl"].setValue([{_id: this._forceCompany.id, name: this._forceCompany.name}]);
				this.folderAddForm.controls["companiesControl"].disable();
			}
			}
		},
		(err: any) => {
			// Cannot load the data.
			this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
		}
		);
  }

	public nodeSelect(event: any): void {
		// Update the path form value.
		this.folderAddForm.controls['pathControl'].setValue(event.node.data);
	}

	public setModalOptions(data:any): void {
		// This indicates, it is used inside another window.
		if (data["FROM"] == "COMPANY-DETAILS") this._forceCompany = data["COMPANY"];
	  	else if (data["FROM"] == "USER-DETAILS") this._forceUser = data["USER"];
  }

	public testMail(): void {
		// Sending a test mail to the current user.
		var mailData = {
			"SUBJECT":this.folderAddForm.controls["emailSubjectControl"].value,
			"INTRODUCTION":this.folderAddForm.controls["emailIntroControl"].value,
			"LINK":this.folderAddForm.controls["emailLinkControl"].value,
			"INFO_BILL":this.folderAddForm.controls["emailInfoBillControl"].value,
			"INFO_ANSWER":this.folderAddForm.controls["emailInfoAnswerControl"].value,
			"NOTA":this.folderAddForm.controls["emailNotaControl"].value,
			"LINK_VALID":this.folderAddForm.controls["emailLinkValidControl"].value,
			"MORE_INFO":this.folderAddForm.controls["emailMoreInfoControl"].value,
			"SIGNATURE":this.folderAddForm.controls["emailSignatureControl"].value
		};
		this.put("/api/folder-test-creation-mail", mailData,
			(response: any) => {
				alert("Votre email de test est envoyé. Le sujet est précédé par '[TEST]'.");
			},
			(err: any) => {
				alert("Erreur d'envoi ("+err+"). Contactez votre administrateur.");
			}
		);
	}

	public save(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			name: this.folderAddForm.controls['nameControl'].value,
			path: this.folderAddForm.controls['pathControl'].value,
			engineer: this.folderAddForm.controls['engineerControl'].value,
			endDate: this.folderAddForm.controls['endDateControl'].value,
			// User rights.
			users: this.folderAddForm.controls['usersControl'].value,
			// Companies rights.
			companies: this.folderAddForm.controls['companiesControl'].value,
			// Mail informations.
			mailSubject: this.folderAddForm.controls['emailSubjectControl'].value,
			mailIntroduction: this.folderAddForm.controls['emailIntroControl'].value,
			mailLink: this.folderAddForm.controls['emailLinkControl'].value,
			mailBill: this.folderAddForm.controls['emailInfoBillControl'].value,
			mailResponse: this.folderAddForm.controls['emailInfoAnswerControl'].value,
			mailNota: this.folderAddForm.controls['emailNotaControl'].value,
			mailLinkValid: this.folderAddForm.controls['emailLinkValidControl'].value,
			mailMoreInfo: this.folderAddForm.controls['emailMoreInfoControl'].value,
			mailSignature: this.folderAddForm.controls['emailSignatureControl'].value,
			mailGetACopy: this.folderAddForm.controls['emailSendToUserControl'].value
		};

		this.put("/api/folder-add", newData, 
			(response: any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					// Inserting the new element in the list.
					var newFolder = {
						_id: response.ID,
						name: newData["name"],
						path: response.PATH,
						endDate: response.ENDDATE,
						endDateVal: response.ENDDATEVAL
					};
					this.modalInstance.dismiss(newFolder);
				}
			},
			(err: any) => {
				this.modalInstance.close(err);
			}
		);
	}

}
